import { getTwoLetterIsoLanguageName, getTwoLetterIsoName, getCapCode } from '@triumph/shared';
import { useDispatch, useSelector } from 'react-redux';
import { setCalculations, setAwaitingCalculation } from 'src/redux/app/actions';
import { getBikeModel, getLoadedConfiguration, getSelectedColour } from 'src/redux/app/selectors';

const useCodeweavers = () => {
  const bikeModel = useSelector(getBikeModel);
  const bikeColour = useSelector(getSelectedColour);
  const { price, thumbnail, colours } = bikeModel;
  const dispatch = useDispatch();
  const loadedConfiguration = useSelector(getLoadedConfiguration);
  const capCode = getCapCode(colours, loadedConfiguration);
  const assetId = `${bikeModel.year}${bikeModel.productCode}${bikeColour?.colourCode}`;

  const initCodeweavers = () => {
    const lsQuoteRef = window.localStorage.getItem('quoteRef');
    const lsBikeId = window.localStorage.getItem('bikeId');
    const lsBikePrice = Number(window.localStorage.getItem('bikePrice'));

    // We re-initialise on option change so dump anything that might pre-exist
    window.codeweavers.dumpMainParameters();

    window.codeweavers.main({
      // The following properties are required
      pluginContentDivId: 'cw-plugin-container',
      quoteReference:
        lsQuoteRef && lsBikeId === assetId && lsBikePrice === Number(loadedConfiguration?.price || price)
          ? lsQuoteRef
          : null,
      vehicle: {
        identifierType: 'TriumphCode',
        identifier: capCode,
        type: 'Bike',
        isNew: true,
        cashPrice: Number(loadedConfiguration?.price || price),
        imageUrl: thumbnail?.src,
        assetImage: thumbnail?.src,
        linkBackUrl: window.location.origin,
        languageCode: getTwoLetterIsoLanguageName(),
        mileage: 0,
        model: bikeModel.name,
        countryCode: getTwoLetterIsoName(),
      },
      onSuccessfulCalculation(calculations) {
        dispatch(setCalculations(calculations));
        dispatch(setAwaitingCalculation(false));
        window.localStorage.setItem('quoteRef', calculations.finance.quote.quoteReference);
        window.localStorage.setItem('quoteLink', calculations.finance.quote.quoteActions.print);
        window.localStorage.setItem('bikeId', assetId);
        window.localStorage.setItem('bikePrice', loadedConfiguration?.price || price);
      },
      settings: {
        analytics: {
          isDisabled: false,
        },
        callToAction: {
          checkout: {
            isVisible: false,
          },
          reserve: {
            isVisible: false,
          },
          apply: {
            isVisible: false,
          },
          creditCheck: {
            isVisible: false,
          },
        },
      },
      defaultParameters: {
        deposit: {
          defaultValue: 0,
        },
        payment: {
          defaultValue: 0,
        },
        term: {
          defaultValue: 0,
        },
        annualMileage: {
          defaultValue: 0,
        },
        settlement: {
          defaultValue: 0,
        },
        partExchange: {
          defaultValue: 0,
        },
      },
    });
  };

  return initCodeweavers;
};

export default useCodeweavers;
